@defer (on viewport; hydrate on immediate) {
	@if (deal$ | async; as deal) {
		<div data-test-id="deal-detail">
			@if (images?.length) {
				<vp-carousel [items]="images" data-test-id="carousel" />
			}
			<section class="section-spacing bg-white">
				<div class="section-inner section-gap flex-col">
					<div class="column-gap flex-col lg:flex-row">
						<div class="flex-col lg:w-2/3">
							<header data-test-class="deal-detail-header">
								<h1
									class="heading-group heading-group-lg"
									data-test-class="title"
								>
									{{ deal?.title || '' }}
								</h1>
								<p
									class="heading-group-overline"
									data-test-class="overline"
									role="doc-subtitle"
								>
									{{ 'global.deal-label' | translate }}
								</p>
							</header>

							@if (deal?.content) {
								<markdown
									[data]="deal.content"
									class="markdown block"
									data-test-class="deal-detail-content"
								/>
							}
						</div>
						<div class="flex-col lg:w-1/3">
							<vp-persuade-card
								[headingType]="'h2'"
								[title]="
									'storyblok.pages.deal-bullet-content'
										| translate
								"
								class="richtext list-checkmarks"
							>
								<ng-container content>
									@if (deal?.bulletContent) {
										<markdown
											[data]="deal.bulletContent"
											class="markdown block"
											data-test-class="deal-detail-bullet-content"
										/>
									}

									@if (deal?.conditions?.[0]?.terms) {
										<sb-sheet
											[linkText]="
												'global.terms-conditions.cta'
													| translate
											"
											[sheetContent]="
												deal.conditions[0].terms
											"
											[sheetTitle]="
												'global.terms-conditions.title'
													| translate
											"
											[useMarkdown]="true"
										/>
									}
								</ng-container>
							</vp-persuade-card>
						</div>
					</div>
				</div>
			</section>
			@if (availableDealHotels().length > 0) {
				<sb-searchable-list-section
					[disabledText]="dealStatusText()"
					[persuadeCards]="availableDealHotels()"
					[title]="listTitle"
					[useStoryblokCards]="false"
				/>
			}

			@for (blok of contentInputs(); track $index) {
				@if (components?.[blok['component']]) {
					<ndc-dynamic
						[ndcDynamicComponent]="components[blok['component']]"
						[ndcDynamicInputs]="blok"
					/>
				}
			}
		</div>
	}
} @placeholder {
	<vp-skeleton />
}
